export default __webpack_public_path__ + "static/media/unknow-state.f872f09b.svg";